var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPiscineSchema(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "piscine_sch\\xE9ma",
    "data-name": "piscine sch\\xE9ma",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 279.784,
    height: 132.192,
    viewBox: "0 0 279.784 132.192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 279.784,
    height: 132.192,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 42.968,
    height: 27.578,
    transform: "translate(183.923 36.013)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 79.786,
    height: 20.686,
    transform: "translate(92.243 66.62)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 12.283,
    height: 27.359,
    transform: "translate(78.873 36.042)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 5.857,
    height: 38.537,
    transform: "translate(100.897 86.49)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 12.344,
    height: 15.601,
    transform: "translate(229.221 66.747)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 9.021,
    height: 11.447,
    transform: "translate(217.703 52.062)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_309",
    "data-name": "Groupe 309",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_308",
    "data-name": "Groupe 308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_307",
    "data-name": "Groupe 307",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_608",
    "data-name": "Trac\\xE9 608",
    d: "M48.091,65.6s39.521,65.865,64.543,58.717C134.43,118.084,217.063,91.319,238,84.524a10.091,10.091,0,0,0,6.458-6.411l4-12.014Z",
    fill: "#60cae1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_609",
    "data-name": "Trac\\xE9 609",
    d: "M75.868,32.482l-31.4,33.7,209.361.511L228.8,31.971Z",
    fill: "#60cae1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_610",
    "data-name": "Trac\\xE9 610",
    d: "M77.08,33c31,7.69,62.97,6.792,94.594,4.792,14.913-.943,29.829-2.077,44.777-2.264,3.507-.044,7.015-.034,10.521.048q1.3.03,2.608.074c.585.02,1.121-.091,1.473.4a3.027,3.027,0,0,1,.2.6c.017.081.035.162.052.242q-.135.893,1.428-.842a4.387,4.387,0,0,0-1.818-.348,2.933,2.933,0,0,0-3.245,3c-.024,1.886.988,3.815,1.866,5.423a33.175,33.175,0,0,0,3.684,5.426c1.655,1.971,3.09,4.067,4.572,6.168a33.176,33.176,0,0,0,5.543,6.389,24.58,24.58,0,0,0,8.869,4.695c1.557.469,2.336-1.426,1.46-2.507L233.536,39.453l-1.818,2.356c8.212,6.266,16,13.581,20.174,23.217l1.295-2.257c-30.24,2.339-60.351-3.119-90.59-1.885-6.754.275-13.434,1.241-20.2.958-3.05-.128-6.1-.359-9.138-.592a66.626,66.626,0,0,0-7.4-.4c-5.427.194-10.775,1.469-16.211,1.509-2.771.02-5.547-.436-8.323-.518-3.353-.1-6.709-.05-10.063.025-7.5.167-14.971.45-22.448,1.089-7.584.648-15.151,1.314-22.765,1.483l1.447,1.9c.493-2.243,4.107-3.269,6.16-3.992,3.032-1.067,6.374-1.931,8.976-3.9a7.256,7.256,0,0,0,2.528-3.473,16.542,16.542,0,0,1,2.528-4.482c2.056-2.608,4.705-4.674,6.769-7.275a17.306,17.306,0,0,0,3.685-12.238,1.512,1.512,0,0,0-2.795-.757A68.039,68.039,0,0,1,56.259,51.6a1.508,1.508,0,0,0,1.156,2.742,8.142,8.142,0,0,0,6.334-5.525c.62-1.833-2.277-2.619-2.893-.8a5.2,5.2,0,0,1-4.239,3.429l1.156,2.742A71.528,71.528,0,0,0,77.936,31.733l-2.795-.757a14.385,14.385,0,0,1-2.885,10.216c-2.03,2.572-4.643,4.616-6.69,7.175a19.939,19.939,0,0,0-2.822,4.6c-.56,1.309-.786,2.265-1.97,3.141C58.246,57.979,54.9,58.7,51.989,59.76c-2.82,1.033-6.657,2.456-7.387,5.777a1.518,1.518,0,0,0,1.446,1.9c13.531-.3,26.959-2.138,40.492-2.457,6.5-.153,13.041-.458,19.525.128,5.4.488,10.617-.387,15.982-.958,5.4-.576,10.718.1,16.118.46,2.977.2,5.962.359,8.946.319,3.255-.043,6.49-.5,9.734-.727,14.995-1.046,30.015-.235,44.991.716,17.1,1.086,34.229,2.177,51.351.853a1.525,1.525,0,0,0,1.295-2.257C250.1,53.4,241.836,45.783,233.232,39.218c-1.457-1.112-2.8,1.147-1.817,2.356L251.546,66.4l1.459-2.507a20.966,20.966,0,0,1-7.786-4.128,30.608,30.608,0,0,1-4.833-5.577c-1.34-1.9-2.618-3.843-4.085-5.648a42.148,42.148,0,0,1-3.387-4.592,15.727,15.727,0,0,1-2.226-4.942,1.8,1.8,0,0,1,.041-.612c.1.052-.251.333-.25.323,0-.06.042-.071.146-.05a6.177,6.177,0,0,0,2.384.252c2.628-.838.858-4.961-.815-5.828-1.378-.714-3.284-.476-4.787-.513q-2.838-.072-5.677-.082c-30.181-.126-60.209,3.976-90.4,3.743-17.988-.138-35.965-1.8-53.453-6.141C76,29.638,75.2,32.531,77.08,33",
    fill: "#25b6d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_611",
    "data-name": "Trac\\xE9 611",
    d: "M49.485,63.205,77.74,30.694l150.894,1.617L251.7,63.375l-5.617.341-19.4-27.575H79.1L54.591,63.375Z",
    fill: "#f9be93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_291",
    "data-name": "Groupe 291",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_290",
    "data-name": "Groupe 290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_289",
    "data-name": "Groupe 289",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_612",
    "data-name": "Trac\\xE9 612",
    d: "M184.067,63.591l-.144-.479c11.962-3.609,21.855-6.562,31.136-9.292,4.728-2.034,6.686-6.929,8.58-11.662a44.215,44.215,0,0,1,2.823-6.146l.429.256a43.18,43.18,0,0,0-2.788,6.075c-1.933,4.832-3.932,9.829-8.86,11.942l-.028.01C205.931,57.027,196.034,59.98,184.067,63.591Z",
    fill: "#a2e9f4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_294",
    "data-name": "Groupe 294",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_293",
    "data-name": "Groupe 293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_292",
    "data-name": "Groupe 292",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_613",
    "data-name": "Trac\\xE9 613",
    d: "M101.145,87.306h-.134l-.074-.111c-2.278-3.416-3.712-7.51-5.1-11.47a65.838,65.838,0,0,0-3.595-8.871l.442-.233a66.208,66.208,0,0,1,3.624,8.94c1.362,3.886,2.769,7.9,4.969,11.246a30.854,30.854,0,0,0,8.683-1.658c1.629-.478,3.313-.972,5.123-1.334,17-5,33.769-10.082,49.99-15l6.81-2.063.145.479-6.809,2.063c-16.225,4.917-33,10-50,15l-.022.005c-1.792.358-3.469.85-5.091,1.326A30.867,30.867,0,0,1,101.145,87.306Z",
    fill: "#a2e9f4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_297",
    "data-name": "Groupe 297",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_296",
    "data-name": "Groupe 296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_295",
    "data-name": "Groupe 295",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_614",
    "data-name": "Trac\\xE9 614",
    d: "M90.708,63.4C87.832,57.564,85.12,51.077,82.5,44.8c-1.247-2.982-2.425-5.8-3.624-8.564l.459-.2c1.2,2.767,2.379,5.586,3.627,8.57,2.62,6.266,5.329,12.746,8.2,18.568Z",
    fill: "#a2e9f4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_300",
    "data-name": "Groupe 300",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_299",
    "data-name": "Groupe 299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_298",
    "data-name": "Groupe 298",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ligne_12",
    "data-name": "Ligne 12",
    d: "M5.114,38.5-.248.035l.5-.069L5.61,38.433Z",
    transform: "translate(101.145 86.524)",
    fill: "#a2e9f4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_303",
    "data-name": "Groupe 303",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_302",
    "data-name": "Groupe 302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_301",
    "data-name": "Groupe 301",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ligne_13",
    "data-name": "Ligne 13",
    d: "M11.844,15.351a.25.25,0,0,1-.2-.1L-.2.154A.25.25,0,0,1-.154-.2.25.25,0,0,1,.2-.154l11.844,15.1a.25.25,0,0,1-.2.4Z",
    transform: "translate(229.471 66.997)",
    fill: "#a2e9f4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_306",
    "data-name": "Groupe 306",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_305",
    "data-name": "Groupe 305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_304",
    "data-name": "Groupe 304",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ligne_14",
    "data-name": "Ligne 14",
    d: "M8.521,11.2a.25.25,0,0,1-.2-.1L-.2.154A.25.25,0,0,1-.154-.2.25.25,0,0,1,.2-.154L8.718,10.793a.25.25,0,0,1-.2.4Z",
    transform: "translate(217.953 52.312)",
    fill: "#a2e9f4"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_615",
    "data-name": "Trac\\xE9 615",
    d: "M230.847,28.311H76.124l-36,38.553H259.953ZM78.932,32.141,228.8,32.4,251.273,63.29H50.938Z",
    fill: "#ffdab6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_616",
    "data-name": "Trac\\xE9 616",
    d: "M259.953,66.865l-1.532,4.34H40.889l-.766-4.34Z",
    fill: "#f9be93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_617",
    "data-name": "Trac\\xE9 617",
    d: "M216.457,21.934c-36.907-5.064-69.528-6.821-96.958-5.223-21.415,1.248-32.665,4.2-35.6,5.079l-.214-.719c2.957-.882,14.278-3.857,35.773-5.11a396.3,396.3,0,0,1,40.187-.111c17.622.779,36.771,2.576,56.916,5.34Z",
    fill: "#5bc1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_618",
    "data-name": "Trac\\xE9 618",
    d: "M87.016,23.746l.346-.666-3.284-1.7,1.936-3.151-.64-.392-2.357,3.838Z",
    fill: "#5bc1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_619",
    "data-name": "Trac\\xE9 619",
    d: "M213.658,24.3l-.439-.609,3-2.158L213.85,18.7l.576-.481,2.889,3.457Z",
    fill: "#5bc1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_620",
    "data-name": "Trac\\xE9 620",
    d: "M36.056,62.328l-.731-.169a43.232,43.232,0,0,1,6.835-14.523,56.043,56.043,0,0,1,9.582-10.461A69.277,69.277,0,0,1,67.3,27.3l.318.679c-10.638,4.984-19,11.744-24.846,20.09A42.458,42.458,0,0,0,36.056,62.328Z",
    fill: "#5bc1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_621",
    "data-name": "Trac\\xE9 621",
    d: "M39.334,60.628l-.4-.635-3.125,1.978-1.744-3.262-.661.355,2.125,3.972Z",
    fill: "#5bc1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_622",
    "data-name": "Trac\\xE9 622",
    d: "M66.635,31.511l-.7-.262,1.294-3.464-3.551-1.037.211-.72,4.324,1.263Z",
    fill: "#5bc1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_623",
    "data-name": "Trac\\xE9 623",
    d: "M94.886,130.53a67.918,67.918,0,0,1-20.81-11.862A89.191,89.191,0,0,1,59.35,103.033,106.287,106.287,0,0,1,46.19,79.758l.7-.274c2.551,6.49,16.866,39.418,48.244,50.338Z",
    fill: "#5bc1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_624",
    "data-name": "Trac\\xE9 624",
    d: "M44.669,83.082l.7.264,1.3-3.463,3.359,1.547.314-.682L46.25,78.865Z",
    fill: "#5bc1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_625",
    "data-name": "Trac\\xE9 625",
    d: "M91.633,132.192l-.293-.691,3.407-1.438-1.683-3.293.669-.341,2.049,4.011Z",
    fill: "#5bc1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_626",
    "data-name": "Trac\\xE9 626",
    d: "M246.31,90.714l-.254-.706c6.707-2.415,6.457-10.452,6.221-12.858l.746-.073a18.7,18.7,0,0,1-.55,6.8,11.057,11.057,0,0,1-2.028,3.961A9.377,9.377,0,0,1,246.31,90.714Z",
    fill: "#5bc1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_627",
    "data-name": "Trac\\xE9 627",
    d: "M249.691,79.794l.58.477,2.345-2.86,2.681,2.548.516-.545-3.265-3.1Z",
    fill: "#5bc1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_628",
    "data-name": "Trac\\xE9 628",
    d: "M247.19,86.476l.689.3-1.471,3.393,3.492,1.219-.248.708L245.4,90.609Z",
    fill: "#5bc1ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_629",
    "data-name": "Trac\\xE9 629",
    d: "M122.858,8.52a.264.264,0,0,1-.2-.078.268.268,0,0,1-.077-.2V.276A.265.265,0,0,1,122.858,0h.564a.266.266,0,0,1,.205.078.284.284,0,0,1,.071.2V8.244a.284.284,0,0,1-.071.2.263.263,0,0,1-.205.078Z",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_630",
    "data-name": "Trac\\xE9 630",
    d: "M128.043,8.64a3.046,3.046,0,0,1-1.524-.348,2.338,2.338,0,0,1-.936-.967,3.3,3.3,0,0,1-.36-1.409c-.008-.137-.012-.31-.012-.522s0-.382.012-.51a3.238,3.238,0,0,1,.366-1.416,2.388,2.388,0,0,1,.941-.96,3.452,3.452,0,0,1,3.025,0,2.39,2.39,0,0,1,.942.96,3.237,3.237,0,0,1,.365,1.416c.008.128.013.3.013.51s-.005.385-.013.522a3.3,3.3,0,0,1-.359,1.409,2.34,2.34,0,0,1-.937.967,3.045,3.045,0,0,1-1.523.348m0-.924a1.545,1.545,0,0,0,1.187-.475,2.078,2.078,0,0,0,.481-1.385q.012-.18.012-.456t-.012-.456a2.083,2.083,0,0,0-.481-1.386,1.544,1.544,0,0,0-1.187-.474,1.564,1.564,0,0,0-1.194.474,2.021,2.021,0,0,0-.474,1.386c-.009.12-.013.272-.013.456s0,.336.013.456a2.016,2.016,0,0,0,.474,1.385,1.565,1.565,0,0,0,1.194.475",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_631",
    "data-name": "Trac\\xE9 631",
    d: "M132.65,8.52a.264.264,0,0,1-.2-.078.268.268,0,0,1-.078-.2V2.556a.267.267,0,0,1,.276-.276h.563a.269.269,0,0,1,.2.078.272.272,0,0,1,.078.2v.528a2.448,2.448,0,0,1,.786-.666,2.532,2.532,0,0,1,1.218-.258,2.449,2.449,0,0,1,1.326.342,2.135,2.135,0,0,1,.822.948,3.372,3.372,0,0,1,.276,1.41V8.244a.281.281,0,0,1-.072.2.247.247,0,0,1-.192.078h-.6a.264.264,0,0,1-.2-.078.268.268,0,0,1-.078-.2V4.92a1.95,1.95,0,0,0-.408-1.314,1.5,1.5,0,0,0-1.2-.474,1.572,1.572,0,0,0-1.194.474,1.832,1.832,0,0,0-.45,1.314V8.244a.268.268,0,0,1-.078.2.264.264,0,0,1-.2.078Z",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_632",
    "data-name": "Trac\\xE9 632",
    d: "M142.2,11.16a3.52,3.52,0,0,1-1.337-.216,2.355,2.355,0,0,1-.817-.522,2,2,0,0,1-.42-.612,1.667,1.667,0,0,1-.138-.486.234.234,0,0,1,.078-.2.284.284,0,0,1,.2-.084h.576a.31.31,0,0,1,.18.049.363.363,0,0,1,.12.2,2.382,2.382,0,0,0,.216.4,1.182,1.182,0,0,0,.444.384,1.79,1.79,0,0,0,.84.162,2.641,2.641,0,0,0,.948-.149,1.093,1.093,0,0,0,.582-.529,2.26,2.26,0,0,0,.2-1.038V7.7a2.285,2.285,0,0,1-.755.618,2.519,2.519,0,0,1-1.177.246,2.621,2.621,0,0,1-1.152-.233A2.172,2.172,0,0,1,140,7.7a2.772,2.772,0,0,1-.456-.918,4.548,4.548,0,0,1-.174-1.08q-.012-.336,0-.66a4.539,4.539,0,0,1,.174-1.079A2.846,2.846,0,0,1,140,3.036a2.134,2.134,0,0,1,.786-.642,2.607,2.607,0,0,1,1.152-.234,2.4,2.4,0,0,1,1.194.27,2.6,2.6,0,0,1,.775.655V2.568a.29.29,0,0,1,.077-.2.258.258,0,0,1,.2-.084h.552a.287.287,0,0,1,.288.288v5.82a3.566,3.566,0,0,1-.27,1.428,2.07,2.07,0,0,1-.887.984,3.3,3.3,0,0,1-1.663.36m-.024-3.552a1.564,1.564,0,0,0,.966-.276,1.641,1.641,0,0,0,.54-.7,2.384,2.384,0,0,0,.186-.852q.012-.168.012-.414c0-.163,0-.3-.012-.414a2.389,2.389,0,0,0-.186-.852,1.647,1.647,0,0,0-.54-.7,1.835,1.835,0,0,0-1.926-.006,1.488,1.488,0,0,0-.516.708,3.254,3.254,0,0,0-.18.942q-.012.312,0,.636a3.254,3.254,0,0,0,.18.942,1.488,1.488,0,0,0,.516.708,1.562,1.562,0,0,0,.96.27",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_633",
    "data-name": "Trac\\xE9 633",
    d: "M149.138,8.64a2.365,2.365,0,0,1-1.3-.342,2.154,2.154,0,0,1-.81-.954,3.382,3.382,0,0,1-.276-1.4V2.556a.267.267,0,0,1,.276-.276h.6a.267.267,0,0,1,.277.276V5.88q0,1.788,1.559,1.788a1.573,1.573,0,0,0,1.195-.474,1.836,1.836,0,0,0,.449-1.314V2.556a.267.267,0,0,1,.276-.276h.588a.264.264,0,0,1,.2.078.281.281,0,0,1,.072.2V8.244a.281.281,0,0,1-.072.2.264.264,0,0,1-.2.078h-.552a.267.267,0,0,1-.276-.276V7.716a2.487,2.487,0,0,1-.786.672,2.541,2.541,0,0,1-1.218.252",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_634",
    "data-name": "Trac\\xE9 634",
    d: "M156.519,8.64a2.6,2.6,0,0,1-1.968-.761,3.15,3.15,0,0,1-.8-2.082c-.007-.105-.011-.239-.011-.4s0-.3.011-.4a3.512,3.512,0,0,1,.4-1.494,2.466,2.466,0,0,1,.954-.99,2.8,2.8,0,0,1,1.422-.348,2.841,2.841,0,0,1,1.53.385,2.452,2.452,0,0,1,.942,1.091,3.963,3.963,0,0,1,.324,1.657v.2a.266.266,0,0,1-.078.2.283.283,0,0,1-.2.072h-4.151v.109a2.506,2.506,0,0,0,.216.917,1.694,1.694,0,0,0,.552.69,1.415,1.415,0,0,0,.864.265,1.712,1.712,0,0,0,.72-.133,1.922,1.922,0,0,0,.708-.54.623.623,0,0,1,.168-.186.472.472,0,0,1,.192-.03h.576a.293.293,0,0,1,.2.066.2.2,0,0,1,.067.186.933.933,0,0,1-.193.438,2.3,2.3,0,0,1-.515.51,2.883,2.883,0,0,1-.817.414,3.411,3.411,0,0,1-1.1.162m-1.632-3.7h3.288V4.908a2.226,2.226,0,0,0-.2-.96,1.6,1.6,0,0,0-.57-.666,1.575,1.575,0,0,0-.888-.246,1.544,1.544,0,0,0-.882.246,1.578,1.578,0,0,0-.559.666,2.285,2.285,0,0,0-.191.96Z",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_635",
    "data-name": "Trac\\xE9 635",
    d: "M163.082,8.64a2.365,2.365,0,0,1-1.3-.342,2.154,2.154,0,0,1-.81-.954,3.382,3.382,0,0,1-.276-1.4V2.556a.267.267,0,0,1,.276-.276h.6a.267.267,0,0,1,.277.276V5.88q0,1.788,1.559,1.788a1.573,1.573,0,0,0,1.195-.474,1.836,1.836,0,0,0,.449-1.314V2.556a.267.267,0,0,1,.276-.276h.588a.264.264,0,0,1,.2.078.281.281,0,0,1,.072.2V8.244a.281.281,0,0,1-.072.2.264.264,0,0,1-.2.078h-.552a.267.267,0,0,1-.276-.276V7.716a2.487,2.487,0,0,1-.786.672,2.541,2.541,0,0,1-1.218.252",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_636",
    "data-name": "Trac\\xE9 636",
    d: "M168.254,8.52a.264.264,0,0,1-.2-.078.268.268,0,0,1-.078-.2V2.568a.289.289,0,0,1,.078-.2.258.258,0,0,1,.2-.084h.552a.287.287,0,0,1,.288.288V3.1a1.529,1.529,0,0,1,.66-.612,2.288,2.288,0,0,1,1.008-.2h.48a.25.25,0,0,1,.192.078.281.281,0,0,1,.072.2v.492a.248.248,0,0,1-.264.264h-.72a1.366,1.366,0,0,0-1.02.378,1.4,1.4,0,0,0-.372,1.026V8.244a.258.258,0,0,1-.084.2.285.285,0,0,1-.2.078Z",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_637",
    "data-name": "Trac\\xE9 637",
    d: "M.275,39.011a.264.264,0,0,1-.2-.078.268.268,0,0,1-.077-.2V30.767a.265.265,0,0,1,.275-.276H.839a.266.266,0,0,1,.205.078.284.284,0,0,1,.071.2v7.968a.284.284,0,0,1-.071.2.263.263,0,0,1-.205.078Z",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_638",
    "data-name": "Trac\\xE9 638",
    d: "M4.643,39.131a2.453,2.453,0,0,1-1.091-.24,2.119,2.119,0,0,1-.792-.647,1.523,1.523,0,0,1-.3-.925A1.552,1.552,0,0,1,3.132,36a3.859,3.859,0,0,1,1.752-.649L6.672,35.1v-.347a1.2,1.2,0,0,0-.331-.9,1.491,1.491,0,0,0-1.074-.324,1.552,1.552,0,0,0-.869.217,1.147,1.147,0,0,0-.462.551.254.254,0,0,1-.252.18h-.54a.242.242,0,0,1-.2-.078.277.277,0,0,1-.066-.186,1.008,1.008,0,0,1,.138-.444,1.807,1.807,0,0,1,.426-.515,2.44,2.44,0,0,1,.737-.426,3.059,3.059,0,0,1,1.1-.175,3.441,3.441,0,0,1,1.211.186,1.961,1.961,0,0,1,.775.5,1.925,1.925,0,0,1,.408.709,2.629,2.629,0,0,1,.125.8v3.888a.268.268,0,0,1-.078.2.264.264,0,0,1-.2.078H6.971a.262.262,0,0,1-.2-.078.285.285,0,0,1-.072-.2v-.516a2.206,2.206,0,0,1-1.08.775,3,3,0,0,1-.972.137m.253-.9a1.924,1.924,0,0,0,.9-.21,1.492,1.492,0,0,0,.643-.653,2.378,2.378,0,0,0,.234-1.116v-.336l-1.392.2a3.219,3.219,0,0,0-1.283.4.835.835,0,0,0-.433.714.81.81,0,0,0,.2.559,1.212,1.212,0,0,0,.5.33,1.9,1.9,0,0,0,.63.107",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_639",
    "data-name": "Trac\\xE9 639",
    d: "M9.8,39.011a.264.264,0,0,1-.2-.078.268.268,0,0,1-.078-.2V33.059a.289.289,0,0,1,.078-.2.258.258,0,0,1,.2-.084h.552a.287.287,0,0,1,.288.288v.528a1.529,1.529,0,0,1,.66-.612,2.288,2.288,0,0,1,1.008-.2h.48a.25.25,0,0,1,.192.078.281.281,0,0,1,.072.2v.492a.248.248,0,0,1-.264.264h-.72a1.366,1.366,0,0,0-1.02.378,1.4,1.4,0,0,0-.372,1.026v3.528a.258.258,0,0,1-.084.2.285.285,0,0,1-.2.078Z",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_640",
    "data-name": "Trac\\xE9 640",
    d: "M16.511,41.651a3.52,3.52,0,0,1-1.337-.216,2.354,2.354,0,0,1-.817-.522,2,2,0,0,1-.42-.612,1.667,1.667,0,0,1-.138-.486.234.234,0,0,1,.078-.2.284.284,0,0,1,.2-.084h.576a.31.31,0,0,1,.18.049.363.363,0,0,1,.12.2,2.382,2.382,0,0,0,.216.4,1.182,1.182,0,0,0,.444.384,1.79,1.79,0,0,0,.84.162,2.641,2.641,0,0,0,.948-.149,1.093,1.093,0,0,0,.582-.529,2.26,2.26,0,0,0,.2-1.038v-.816a2.285,2.285,0,0,1-.755.618,2.518,2.518,0,0,1-1.177.246,2.621,2.621,0,0,1-1.152-.233,2.172,2.172,0,0,1-.786-.637,2.772,2.772,0,0,1-.456-.918,4.548,4.548,0,0,1-.174-1.08q-.012-.336,0-.66a4.539,4.539,0,0,1,.174-1.079,2.846,2.846,0,0,1,.456-.925,2.134,2.134,0,0,1,.786-.642,2.607,2.607,0,0,1,1.152-.234,2.4,2.4,0,0,1,1.194.27,2.6,2.6,0,0,1,.775.655v-.517a.29.29,0,0,1,.077-.2.258.258,0,0,1,.2-.084h.552a.287.287,0,0,1,.288.288v5.82a3.566,3.566,0,0,1-.27,1.428,2.07,2.07,0,0,1-.887.984,3.3,3.3,0,0,1-1.663.36M16.487,38.1a1.564,1.564,0,0,0,.966-.276,1.641,1.641,0,0,0,.54-.7,2.384,2.384,0,0,0,.186-.852q.012-.168.012-.414c0-.163,0-.3-.012-.414a2.389,2.389,0,0,0-.186-.852,1.647,1.647,0,0,0-.54-.7,1.835,1.835,0,0,0-1.926-.006,1.488,1.488,0,0,0-.516.708,3.254,3.254,0,0,0-.18.942q-.012.312,0,.636a3.254,3.254,0,0,0,.18.942,1.488,1.488,0,0,0,.516.708,1.562,1.562,0,0,0,.96.27",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_641",
    "data-name": "Trac\\xE9 641",
    d: "M23.6,39.131a2.6,2.6,0,0,1-1.968-.761,3.15,3.15,0,0,1-.805-2.082c-.007-.1-.011-.239-.011-.4s0-.3.011-.4a3.512,3.512,0,0,1,.4-1.494,2.467,2.467,0,0,1,.954-.99,2.8,2.8,0,0,1,1.422-.348,2.841,2.841,0,0,1,1.53.385,2.452,2.452,0,0,1,.942,1.091,3.963,3.963,0,0,1,.324,1.657v.2a.266.266,0,0,1-.078.2.283.283,0,0,1-.2.072H21.972v.109a2.506,2.506,0,0,0,.216.917,1.694,1.694,0,0,0,.552.69,1.415,1.415,0,0,0,.864.265,1.712,1.712,0,0,0,.72-.133,1.922,1.922,0,0,0,.708-.54.623.623,0,0,1,.168-.186.472.472,0,0,1,.192-.03h.576a.293.293,0,0,1,.2.066.2.2,0,0,1,.067.186.933.933,0,0,1-.193.438,2.305,2.305,0,0,1-.515.51,2.884,2.884,0,0,1-.817.414,3.411,3.411,0,0,1-1.1.162m-1.632-3.7H25.26V35.4a2.226,2.226,0,0,0-.2-.96,1.6,1.6,0,0,0-.57-.666,1.575,1.575,0,0,0-.888-.246,1.544,1.544,0,0,0-.882.246,1.578,1.578,0,0,0-.559.666,2.285,2.285,0,0,0-.191.96Z",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_642",
    "data-name": "Trac\\xE9 642",
    d: "M30.167,39.131a2.365,2.365,0,0,1-1.3-.342,2.154,2.154,0,0,1-.81-.954,3.383,3.383,0,0,1-.276-1.4V33.047a.267.267,0,0,1,.276-.276h.6a.267.267,0,0,1,.277.276v3.324q0,1.788,1.559,1.788a1.573,1.573,0,0,0,1.2-.474,1.836,1.836,0,0,0,.449-1.314V33.047a.267.267,0,0,1,.276-.276H33a.264.264,0,0,1,.2.078.281.281,0,0,1,.072.2v5.688a.281.281,0,0,1-.072.2.264.264,0,0,1-.2.078h-.552a.267.267,0,0,1-.276-.276v-.528a2.487,2.487,0,0,1-.786.672,2.541,2.541,0,0,1-1.218.252",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_643",
    "data-name": "Trac\\xE9 643",
    d: "M35.339,39.011a.264.264,0,0,1-.2-.078.268.268,0,0,1-.078-.2V33.059a.289.289,0,0,1,.078-.2.258.258,0,0,1,.2-.084h.552a.287.287,0,0,1,.288.288v.528a1.529,1.529,0,0,1,.66-.612,2.288,2.288,0,0,1,1.008-.2h.48a.25.25,0,0,1,.192.078.281.281,0,0,1,.072.2v.492a.248.248,0,0,1-.264.264h-.72a1.366,1.366,0,0,0-1.02.378,1.4,1.4,0,0,0-.372,1.026v3.528a.258.258,0,0,1-.084.2.285.285,0,0,1-.2.078Z",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_644",
    "data-name": "Trac\\xE9 644",
    d: "M36.774,121.224a.264.264,0,0,1-.2-.078.268.268,0,0,1-.078-.2V115.26a.267.267,0,0,1,.276-.276h.54a.267.267,0,0,1,.276.276v.42a2.033,2.033,0,0,1,.7-.594,2.131,2.131,0,0,1,1.008-.222,1.956,1.956,0,0,1,1.919,1.1,2.054,2.054,0,0,1,.805-.8,2.386,2.386,0,0,1,1.2-.3,2.268,2.268,0,0,1,1.134.288,2,2,0,0,1,.8.87,3.222,3.222,0,0,1,.294,1.458v3.468a.272.272,0,0,1-.078.2.266.266,0,0,1-.2.078H44.61a.263.263,0,0,1-.2-.078.268.268,0,0,1-.078-.2v-3.36a2.394,2.394,0,0,0-.192-1.056,1.132,1.132,0,0,0-.516-.54,1.614,1.614,0,0,0-.708-.156,1.459,1.459,0,0,0-.636.156,1.222,1.222,0,0,0-.534.54,2.217,2.217,0,0,0-.21,1.056v3.36a.267.267,0,0,1-.276.276H40.7a.264.264,0,0,1-.2-.078.269.269,0,0,1-.079-.2v-3.36a2.273,2.273,0,0,0-.2-1.056,1.191,1.191,0,0,0-.528-.54,1.557,1.557,0,0,0-.684-.156,1.456,1.456,0,0,0-.636.156,1.222,1.222,0,0,0-.534.54,2.186,2.186,0,0,0-.21,1.044v3.372a.268.268,0,0,1-.078.2.264.264,0,0,1-.2.078Z",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_645",
    "data-name": "Trac\\xE9 645",
    d: "M48.906,121.344a2.457,2.457,0,0,1-1.092-.24,2.119,2.119,0,0,1-.792-.647,1.523,1.523,0,0,1-.3-.925,1.552,1.552,0,0,1,.672-1.319,3.864,3.864,0,0,1,1.752-.649l1.788-.252v-.347a1.206,1.206,0,0,0-.33-.9,1.493,1.493,0,0,0-1.074-.324,1.557,1.557,0,0,0-.87.217,1.158,1.158,0,0,0-.462.551.254.254,0,0,1-.252.18h-.54a.242.242,0,0,1-.2-.078.277.277,0,0,1-.066-.186,1.008,1.008,0,0,1,.138-.444,1.807,1.807,0,0,1,.426-.515,2.433,2.433,0,0,1,.738-.426,3.053,3.053,0,0,1,1.1-.175,3.447,3.447,0,0,1,1.212.186,1.95,1.95,0,0,1,.774.5,1.911,1.911,0,0,1,.408.709,2.63,2.63,0,0,1,.126.8v3.888a.268.268,0,0,1-.078.2.264.264,0,0,1-.2.078h-.552a.26.26,0,0,1-.2-.078.281.281,0,0,1-.072-.2v-.516a2.208,2.208,0,0,1-.42.426,2.232,2.232,0,0,1-.66.349,3.006,3.006,0,0,1-.972.137m.252-.9a1.925,1.925,0,0,0,.9-.21,1.49,1.49,0,0,0,.642-.653,2.378,2.378,0,0,0,.234-1.116v-.336l-1.392.2a3.219,3.219,0,0,0-1.283.4.835.835,0,0,0-.433.714.81.81,0,0,0,.2.559,1.212,1.212,0,0,0,.5.33,1.9,1.9,0,0,0,.63.107",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_646",
    "data-name": "Trac\\xE9 646",
    d: "M53.5,121.224a.252.252,0,0,1-.174-.072.235.235,0,0,1-.078-.18.274.274,0,0,1,.019-.09.542.542,0,0,1,.065-.126l2.088-2.724-1.955-2.58a.643.643,0,0,1-.067-.12.294.294,0,0,1-.017-.1.243.243,0,0,1,.071-.18.247.247,0,0,1,.181-.072h.611a.269.269,0,0,1,.2.066c.044.044.082.086.115.126l1.6,2.076,1.6-2.064q.048-.06.114-.132a.258.258,0,0,1,.2-.072h.587a.246.246,0,0,1,.252.252.27.27,0,0,1-.017.1.643.643,0,0,1-.067.12l-1.98,2.6,2.089,2.7a.615.615,0,0,1,.065.12.273.273,0,0,1,.019.1.246.246,0,0,1-.252.252h-.637a.287.287,0,0,1-.191-.06.8.8,0,0,1-.12-.12l-1.693-2.2-1.691,2.2c-.032.033-.071.07-.114.114a.267.267,0,0,1-.2.066Z",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_647",
    "data-name": "Trac\\xE9 647",
    d: "M60.438,113.82a.267.267,0,0,1-.276-.276V112.9a.267.267,0,0,1,.276-.276h.756a.267.267,0,0,1,.276.276v.648a.267.267,0,0,1-.276.276Zm.1,7.4a.264.264,0,0,1-.2-.078.268.268,0,0,1-.078-.2V115.26a.267.267,0,0,1,.276-.276h.576a.249.249,0,0,1,.192.078.281.281,0,0,1,.072.2v5.688a.281.281,0,0,1-.072.2.245.245,0,0,1-.192.078Z",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_648",
    "data-name": "Trac\\xE9 648",
    d: "M260.945,91.607a.264.264,0,0,1-.2-.078.268.268,0,0,1-.078-.2V85.643a.267.267,0,0,1,.276-.276h.54a.267.267,0,0,1,.276.276v.42a2.033,2.033,0,0,1,.7-.594,2.131,2.131,0,0,1,1.008-.222,1.956,1.956,0,0,1,1.919,1.1,2.054,2.054,0,0,1,.8-.8,2.386,2.386,0,0,1,1.2-.3,2.269,2.269,0,0,1,1.134.288,2,2,0,0,1,.8.87,3.221,3.221,0,0,1,.294,1.458v3.468a.272.272,0,0,1-.078.2.266.266,0,0,1-.2.078h-.564a.263.263,0,0,1-.2-.078.268.268,0,0,1-.078-.2v-3.36a2.394,2.394,0,0,0-.192-1.056,1.132,1.132,0,0,0-.516-.54,1.614,1.614,0,0,0-.708-.156,1.459,1.459,0,0,0-.636.156,1.221,1.221,0,0,0-.534.54,2.217,2.217,0,0,0-.21,1.056v3.36a.267.267,0,0,1-.276.276h-.564a.264.264,0,0,1-.2-.078.269.269,0,0,1-.079-.2v-3.36a2.274,2.274,0,0,0-.2-1.056,1.191,1.191,0,0,0-.528-.54,1.557,1.557,0,0,0-.684-.156,1.456,1.456,0,0,0-.636.156,1.222,1.222,0,0,0-.534.54,2.187,2.187,0,0,0-.21,1.044v3.372a.268.268,0,0,1-.078.2.264.264,0,0,1-.2.078Z",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_649",
    "data-name": "Trac\\xE9 649",
    d: "M271.517,84.2a.267.267,0,0,1-.276-.276v-.648a.267.267,0,0,1,.276-.276h.756a.267.267,0,0,1,.276.276v.648a.267.267,0,0,1-.276.276Zm.1,7.4a.264.264,0,0,1-.2-.078.268.268,0,0,1-.078-.2V85.643a.267.267,0,0,1,.276-.276h.576a.249.249,0,0,1,.192.078.281.281,0,0,1,.072.2v5.688a.281.281,0,0,1-.072.2.245.245,0,0,1-.192.078Z",
    fill: "#1b9bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_650",
    "data-name": "Trac\\xE9 650",
    d: "M274.517,91.607a.264.264,0,0,1-.2-.078.268.268,0,0,1-.078-.2V85.643a.267.267,0,0,1,.276-.276h.563a.269.269,0,0,1,.2.078.272.272,0,0,1,.078.2v.528a2.448,2.448,0,0,1,.786-.666,2.532,2.532,0,0,1,1.218-.258,2.449,2.449,0,0,1,1.326.342,2.135,2.135,0,0,1,.822.948,3.372,3.372,0,0,1,.276,1.41v3.384a.281.281,0,0,1-.072.2.247.247,0,0,1-.192.078h-.6a.264.264,0,0,1-.2-.078.268.268,0,0,1-.078-.2V88.007a1.95,1.95,0,0,0-.408-1.314,1.5,1.5,0,0,0-1.2-.474,1.572,1.572,0,0,0-1.194.474,1.832,1.832,0,0,0-.45,1.314v3.324a.268.268,0,0,1-.078.2.264.264,0,0,1-.2.078Z",
    fill: "#1b9bd7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiscineSchema);
export default __webpack_public_path__ + "static/media/piscine-schema.654433556087888c06487206fbab10bb.svg";
export { ForwardRef as ReactComponent };